import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import LanguageIcon from "@material-ui/icons/Language";
import { useIdiomaContext } from "./IdiomaContext";

const ETIQUETAS_IDIOMA = {
  es: "Español",
  en: "English",
  fr: "Français",
  it: "Italiano",
  de: "Deutsch",
  pt: "Português",
};

const MARGEN_POR_DEFECTO = 12;

// Dado "top-right"/"top-left"/"bottom-right"/"bottom-left" y el margen en
// px, calcula el estilo fijo del botón y hacia dónde debe abrir el menú
// para que nunca quede recortado fuera de la pantalla (si el botón está
// abajo, el menú abre hacia arriba; si está a la derecha, se alinea a la
// derecha).
function resolverPosicion(posicionBoton, margenBoton) {
  const [vertical, horizontal] = (posicionBoton || "top-right").split("-");
  const margen =
    margenBoton !== undefined ? margenBoton : MARGEN_POR_DEFECTO;

  const estiloBoton = { position: "fixed", zIndex: 1201 };
  estiloBoton[vertical === "top" ? "top" : "bottom"] = margen;
  estiloBoton[horizontal === "left" ? "left" : "right"] = margen;

  const anchorOrigin = {
    vertical: vertical === "top" ? "bottom" : "top",
    horizontal,
  };
  const transformOrigin = {
    vertical: vertical === "top" ? "top" : "bottom",
    horizontal,
  };

  return { estiloBoton, anchorOrigin, transformOrigin };
}

// Botón flotante de idioma, fijo en la esquina de la pantalla que el
// organizador elija (por defecto arriba a la derecha), para que sea
// visible sin importar qué tan abajo esté la sección de inscripción.
export default function IdiomaSwitcherFlotante() {
  const {
    idioma,
    setIdioma,
    idiomasDisponibles,
    posicionBoton,
    tamanoBoton,
    margenBoton,
  } = useIdiomaContext();
  const [anchorEl, setAnchorEl] = useState(null);

  if (!idiomasDisponibles || idiomasDisponibles.length <= 1) {
    return null;
  }

  const { estiloBoton, anchorOrigin, transformOrigin } = resolverPosicion(
    posicionBoton,
    margenBoton
  );

  function elegir(codigo) {
    setIdioma(codigo);
    setAnchorEl(null);
  }

  return (
    <div style={estiloBoton}>
      <Button
        variant="contained"
        color="primary"
        size={tamanoBoton || "medium"}
        startIcon={<LanguageIcon />}
        onClick={(event) => setAnchorEl(event.currentTarget)}
        style={{ borderRadius: 20 }}
      >
        {ETIQUETAS_IDIOMA[idioma] || idioma}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
      >
        {idiomasDisponibles.map((codigo) => (
          <MenuItem key={codigo} selected={codigo === idioma} onClick={() => elegir(codigo)}>
            {ETIQUETAS_IDIOMA[codigo] || codigo}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
}
